<app-nav></app-nav>
<section class="settings" *ngIf="showSettings">
  <div class="container">
    <div class="col">
      <button class="btn btn-checkIn" routerLink="/profile">Set Profile</button>
    </div>
    <!-- <div class="col top-gap-sm">
      <button class="btn btn-checkIn">Set Notification</button>
    </div> -->
    <div class="col top-gap-sm">
      <button class="btn btn-checkIn" routerLink="/aboutUs">About Us</button>
    </div>
  </div>
</section>
